import {useNavigate} from 'react-router-dom';
import {getState} from '../lib/store';
import ModalsLib from '../lib/modals';
import Cookies from 'react-cookies';

const NavigationHandler = location => {
    const search = new URLSearchParams(location.search);

    if(search.get('lx_notification_id') !== null && search.get('lx_notification_source') !== null) {
        Cookies.save('lx-notification-id', search.get('lx_notification_id'));
        Cookies.save('lx-notification-source', search.get('lx_notification_source'));
    }
}

const navigate = (path, afterChange) => {
    const {user} = getState();

    if(!user.user && path !== "/")
        return ModalsLib.open('signin');

    window.dispatchEvent(new CustomEvent('location.change', {
        detail: {
            path: path != window.location.pathname ? path : null,
            afterChange
        }
    }));
}

const NavigationLink = ({path, children}) => {
    return (
        <div onClick={() => navigate(path)}>
            {children}
        </div>
    )
}

export {
    NavigationLink,
    navigate,
    NavigationHandler
}

export default {
    navigate
}